export default __webpack_public_path__ + "assets/images/6c0a1f0895b5d1f567c282972664215e.svg";